import React from "react";
import vision1 from "../../Assets/Images/vision1.png";
import vision2 from "../../Assets/Images/vision2.png";
import vision3 from "../../Assets/Images/vision3.png";
import vision4 from "../../Assets/Images/vision4.png";

const Card = ({ title, text, icon }) => (
  <div className="relative bg-white shadow-md rounded-lg p-5 sm:p-6 lg:p-8">
    <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-[#001659]">
      {title}
    </h2>
    <div className="absolute top-4 right-4 w-10 h-10 sm:w-12 sm:h-12 bg-primaryOrange rounded-full flex items-center justify-center">
      {icon}
    </div>
    <p className="text-gray-600 mt-3 text-sm sm:text-base leading-relaxed pr-10">
      {text}
    </p>
  </div>
);

const OurVisionDesign = () => {
  return (
    <div className="bg-white px-4 sm:px-6 md:px-10 lg:px-16 xl:px-20 py-8 sm:py-12 md:py-16">
      {/* Title */}
      <h1 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-900 mb-10">
        Our <span className="text-[#FF6B35]">Vision</span>
      </h1>

      {/* Top Row */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-12">
        {/* Text Section */}
        <div className="flex flex-col gap-6">
          <Card
            title="For the Company"
            text="To be a leading real estate brand known for excellence, innovation, and integrity. We aspire to set new benchmarks in quality and customer satisfaction while continuously expanding our reach and impact."
            icon={
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
            }
          />
          <Card
            title="For Society"
            text="To create vibrant, sustainable communities that enhance the quality of life. Our developments are designed to promote harmony, well-being, and long-term value, contributing to a better future for all."
            icon={
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z"
                  clipRule="evenodd"
                />
              </svg>
            }
          />
        </div>

        {/* Image Section */}
        <div className="grid grid-cols-3 gap-3">
          <div className="col-span-2 rounded-lg overflow-hidden">
            <img src={vision1} alt="vision 1" className="w-full h-full object-cover" />
          </div>
          <div className="rounded-lg overflow-hidden">
            <img src={vision2} alt="vision 2" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
        {/* Image Section */}
        <div className="grid grid-cols-3 gap-3 order-2 xl:order-1">
          <div className="rounded-lg overflow-hidden">
            <img src={vision3} alt="vision 3" className="w-full h-full object-cover" />
          </div>
          <div className="col-span-2 rounded-lg overflow-hidden">
            <img src={vision4} alt="vision 4" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Text Section */}
        <div className="flex flex-col gap-6 order-1 xl:order-2">
          <Card
            title="For Technology"
            text="To embrace cutting-edge advancements in construction, smart living, and sustainable design. We aim to integrate modern technology to enhance efficiency, safety, and convenience in all our projects."
            icon={
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                  clipRule="evenodd"
                />
              </svg>
            }
          />
          <Card
            title="For Employment"
            text="To be an employer of choice, fostering a dynamic and inclusive work environment. We are committed to empowering our employees with opportunities for growth, learning, and professional excellence."
            icon={
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
                <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
              </svg>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default OurVisionDesign;
